// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-2A8RP","fadeIn":"index-fadeIn-35ZY2"};